var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wk-location",
      on: {
        mouseenter: function ($event) {
          _vm.hovering = true
        },
        mouseleave: function ($event) {
          _vm.hovering = false
        },
      },
    },
    [
      _c(
        "el-input",
        {
          attrs: {
            disabled: _vm.disabled,
            readonly: "",
            clearable: "",
            placeholder: "点击定位",
          },
          on: { clear: _vm.inputClear },
          nativeOn: {
            click: function ($event) {
              return _vm.inputClick.apply(null, arguments)
            },
          },
          model: {
            value: _vm.dataValue.address,
            callback: function ($$v) {
              _vm.$set(_vm.dataValue, "address", $$v)
            },
            expression: "dataValue.address",
          },
        },
        [
          _c("template", { slot: "suffix" }, [
            _vm.dataValue.address && _vm.hovering
              ? _c("i", {
                  staticClass: "el-icon-circle-close",
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.inputClear.apply(null, arguments)
                    },
                  },
                })
              : _c("i", { staticClass: "wk wk-icon-location" }),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("wk-location-point-dialog", {
        attrs: { value: _vm.dataValue, visible: _vm.pointDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.pointDialogVisible = $event
          },
          select: _vm.pointSelect,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }